import React, {useContext, useEffect, useState, useCallback, useMemo} from "react";
import BedRockContext from "../../BedRockContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";
import {ENTITY_ID_USER} from "../generic/Constants";
import {TrueFalseColumnFormatter} from "../../column-formatters/TrueFalseColumnFormatter";
import {DMSDateColumnFormatter} from "../../column-formatters/DMSDateColumnFormatter";
import {useGenericSync} from "../../hooks/useGenericSync";
import {withSyncDot} from "../../column-formatters/SyncStatusColumnFormatter";

export function UsersPage() {
    const myData = useContext(BedRockContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);

    const reloadData = useCallback(() => {
        setReload(prev => prev + 1);
    }, []);

    // Use generic sync hook
    const {
        syncEnabled,
        syncToolbarButtons,
        SyncDialog
    } = useGenericSync(ENTITY_ID_USER, reloadData);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    // Build columns with sync dot on first column if enabled
    const columns = useMemo(() => {
        const nameFormatter = (cell) => cell || '';
        const baseColumns = [
            {
                dataField: "name",
                text: "Full Name",
                search: true,
                formatter: syncEnabled ? withSyncDot(nameFormatter) : undefined
            },
            {
                dataField: "id",
                text: "User Name",
                formatter: HeaderColumnFormatter
            },
            {
                dataField: "phone",
                text: "Phone",
            },
            {
                dataField: "loginCount",
                text: "Login Count",
            },
            {
                dataField: "loginDate",
                text: "Last Login",
                formatter: DMSDateColumnFormatter,
            },
            {
                dataField: "active",
                text: "Active",
                formatter: TrueFalseColumnFormatter,
                formatExtraData: {
                    data: [
                        {
                            value: "true",
                            displayText: "ACTIVE",
                            color: "primary",
                        },
                        {
                            value: "false",
                            displayText: "INACTIVE",
                            color: "danger",
                        },
                    ],
                },
            },
        ];

        return baseColumns;
    }, [syncEnabled]);

    useEffect(() => {
        // Only sync buttons - no add/edit buttons for view-only mode
        const toolBarButtons = [
            ...syncToolbarButtons,
        ];

        myData.setBaseData({ toolBarButtons });
        setPageLoadComplete(true);
    }, [syncToolbarButtons]);

    const BaseCard = () => (
        <div className="card card-body">
            {pageLoadComplete && (
                <>
                    <div className="alert alert-info d-flex align-items-center mb-4">
                        <i className="fas fa-info-circle me-3 fs-4"></i>
                        <div>
                            <strong>Users - View Only</strong>
                            <br />
                            <small>
                                This page displays users synchronized from the server.
                                Users are read-only and managed from the server application.
                                {syncEnabled && " Use Pull from Server to get the latest updates."}
                            </small>
                        </div>
                    </div>
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_USER}
                    />
                </>
            )}
        </div>
    );

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Users</PageTitle>
            <BaseCard/>
            <SyncDialog />
        </>
    );
}
